import { SpinIcon } from "../Icons";
import { twMerge } from "tailwind-merge";

const LOADING_INDICATOR_SIZE = {
  xs: "h-4 w-4",
  sm: "h-6 w-6",
  base: "h-8 w-8",
  lg: "h-10 w-10",
  xl: "h-12 w-12",
};

export type LoadingIndicatorProps = {
  className?: string;
  loadingIndicatorSize?: "xs" | "sm" | "base" | "lg" | "xl";
};

const LoadingIndicator = ({ className, loadingIndicatorSize = "base" }: LoadingIndicatorProps) => {
  return (
    <SpinIcon
      className={twMerge("animate-spin", LOADING_INDICATOR_SIZE[loadingIndicatorSize], className)}
      data-testid="loading-indicator"
    />
  );
};

export default LoadingIndicator;
